export * from './cookieConsent.component'
